import React, { useState } from 'react'
import { redirectTo, concatParamsToUrl } from 'src/utils/Http';
import * as Urls from 'src/constants/EndpointUrls';
import _ from 'lodash'
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { useTranslation } from 'react-i18next'

export default function Step3Modal({ cookie }) {
  const [onOpenModal, setOnOpenModal] = useState(true)
  const setOnCloseModal = () => setOnOpenModal(false)
  const { t } = useTranslation()
  const { run, type, stepIndex, employeeId } = cookie
  const editUrl = (url, formatId) => concatParamsToUrl(url, { ...formatId });
  const onConfirm = () => {
    if (cookie && run) {
      if (run && type == 'setInfo') {
        if (stepIndex == 1) {
          redirectTo(Urls.EMPLOYEES_LIST)
        }
        else if (stepIndex > 1) {
          redirectTo(Urls.EMPLOYEE_NEW + `?employee_id=${employeeId}`)
        }
      }
      else if (run && type == 'checkInfo') {
        redirectTo(editUrl(Urls.EMPLOYEE_EDIT, { id: employeeId }))
      }
    }
  }

  return (
    <CommonModal hideModal={setOnCloseModal} isOpen={onOpenModal} ariaHideApp={false}>
      <CommonModal.Header hideModal={setOnCloseModal}>{t('features.GuideTour.Modal.Title')}</CommonModal.Header>
      <CommonModal.Body>{t('features.GuideTour.Modal.ContinueWorkingTutorial')} </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons>
          <Button onClick={setOnCloseModal}>{t('features.GuideTour.Button.close')}</Button>
          <Button primary onClick={onConfirm}>{t('features.GuideTour.Button.next')}</Button>
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </CommonModal>
  )
}
